// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1vUk5","footer":"ModalFilter_footer__IdBHS"};